"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScopedResetClass = exports.DEFENSIVE_DESCENDANT_RULES = void 0;
const css_1 = require("./css");
const reset_rules_1 = require("./reset-rules");
const fonts_1 = require("./fonts");
const CLASS = 'jj-reset';
// Two scopes with different cascade weight:
//
//  - Root decls (`font-family`, `color`, `accent-color`, etc.) apply only to
//  the boundary element itself. Doubled-class specificity `(0,2,0)` so
//  host rules at `(0,0,1)` / `(0,1,0)` lose.
//  - Descendant decls (`:where(h1,...) {margin: 0}`, `a,button {bdrad: 2px}`,
//  `button:focus-visible {outline}`, etc.) need to STAY OUT OF THE WAY of
//  component classes inside mu-txt.
const ROOT_SELECTOR = `.${CLASS}.${CLASS}`;
const DESCENDANT_SCOPE = `:where(.${CLASS})`;
let emitted = false;
const DEFENSIVE_ROOT_DECLS = {
    ta: 'start',
    textTransform: 'none',
    letterSpacing: 'normal',
    wordSpacing: 'normal',
    whiteSpace: 'normal',
    cur: 'auto',
    caretColor: 'auto',
};
exports.DEFENSIVE_DESCENDANT_RULES = {
    svg: { d: 'inline-block', va: 'middle' },
};
const getScopedResetClass = () => {
    if (emitted)
        return CLASS;
    emitted = true;
    (0, fonts_1.loadGoogleFonts)();
    (0, css_1.put)(ROOT_SELECTOR, { ...reset_rules_1.ROOT_DECLS, ...DEFENSIVE_ROOT_DECLS });
    (0, css_1.put)(DESCENDANT_SCOPE, { ...reset_rules_1.DESCENDANT_RULES, ...exports.DEFENSIVE_DESCENDANT_RULES });
    // Keyframes are name-scoped globally by definition; emit once.
    (0, css_1.put)('', reset_rules_1.KEYFRAMES);
    return CLASS;
};
exports.getScopedResetClass = getScopedResetClass;
